export default __webpack_public_path__ + "static/media/urlPortfolioThumbnail.0e37b10d.svg";